// Generated plan of the « Carte du projet » screen (SPEC-031), from the roadmap
// (docs/00-overview/04-roadmap.md). Texts are in the i18n catalogue (roadmap.*).
// `live`: the status comes from the portal's state (GET /roadmap/live), not from the plan.
export type PhaseId = 'S1' | 'S2' | 'S3' | 'S4' | 'L2' | 'L3' | 'L4' | 'L5';
export type LiveKey = 'entra' | 'teams' | 'github' | 'enrolment' | 'scaleway';
export interface PlanNode { id: string; col: 0 | 1 | 2 | 3; phase: PhaseId; live?: LiveKey; action?: boolean }
export interface PlanEdge { from: string; to: string; phase: PhaseId; live?: LiveKey }
export interface PlanFeature { id: string; phase: PhaseId; live?: LiveKey; action?: boolean; nodes: string[]; edges: string[] }

export const PHASES: PhaseId[] = ['S1', 'S2', 'S3', 'S4', 'L2', 'L3', 'L4', 'L5'];
/** The last phase delivered. */
export const NOW: PhaseId = 'S4';
export const PLAN_DATE = '2026-10-18';

export const NODES: PlanNode[] = [
  { id: 's_login', col: 0, phase: 'S1' },
  { id: 's_servers', col: 0, phase: 'S1' },
  { id: 's_import', col: 0, phase: 'S1' },
  { id: 's_settings', col: 0, phase: 'S1' },
  { id: 's_inventory', col: 0, phase: 'S2' },
  { id: 's_newproject', col: 0, phase: 'S2' },
  { id: 's_dashboard', col: 0, phase: 'S3' },
  { id: 's_supervision', col: 0, phase: 'S3' },
  { id: 's_routing', col: 0, phase: 'S3' },
  { id: 's_domains', col: 0, phase: 'S3' },
  { id: 's_search', col: 0, phase: 'S4' },
  { id: 's_audit', col: 0, phase: 'S4' },
  { id: 's_logs', col: 0, phase: 'L2' },
  { id: 's_security', col: 0, phase: 'L3' },
  { id: 's_ssh', col: 0, phase: 'L4' },
  { id: 's_reports', col: 0, phase: 'L5' },
  { id: 'b_auth', col: 1, phase: 'S1' },
  { id: 'b_fleet', col: 1, phase: 'S1' },
  { id: 'b_provisioning', col: 1, phase: 'S1' },
  { id: 'b_access', col: 1, phase: 'S1' },
  { id: 'b_notif', col: 1, phase: 'S1' },
  { id: 'b_audit', col: 1, phase: 'S1' },
  { id: 'b_catalog', col: 1, phase: 'S1' },
  { id: 'b_portal', col: 1, phase: 'S2' },
  { id: 'b_scaffolder', col: 1, phase: 'S2' },
  { id: 'b_github', col: 1, phase: 'S2' },
  { id: 'b_decisions', col: 1, phase: 'S3' },
  { id: 'b_logs', col: 1, phase: 'L2' },
  { id: 'b_updates', col: 1, phase: 'L3' },
  { id: 'b_order', col: 1, phase: 'L5' },
  { id: 'e_entra', col: 2, phase: 'S1', live: 'entra', action: true },
  { id: 'e_checkmk', col: 2, phase: 'S1' },
  { id: 'e_ansible', col: 2, phase: 'S1' },
  { id: 'e_ovh', col: 2, phase: 'S1' },
  { id: 'e_teams', col: 2, phase: 'S1', live: 'teams', action: true },
  { id: 'e_github', col: 2, phase: 'S2', live: 'github', action: true },
  { id: 'e_smtp', col: 2, phase: 'S3' },
  { id: 'e_sms', col: 2, phase: 'S3' },
  { id: 'e_kuma', col: 2, phase: 'S3' },
  { id: 'e_rdap', col: 2, phase: 'S3' },
  { id: 'e_siem', col: 2, phase: 'S3' },
  { id: 'e_onepassword', col: 2, phase: 'S4' },
  { id: 'e_loki', col: 2, phase: 'L2' },
  { id: 'e_wazuh', col: 2, phase: 'L3' },
  { id: 'e_semaphore', col: 2, phase: 'L3' },
  { id: 'e_openbao', col: 2, phase: 'L4' },
  { id: 'f_servers', col: 3, phase: 'S1', live: 'enrolment', action: true },
  { id: 'f_catalog', col: 3, phase: 'S2' },
  { id: 'f_repos', col: 3, phase: 'S2' },
  { id: 'f_scaleway', col: 3, phase: 'S1', live: 'scaleway', action: true },
];

export const EDGES: PlanEdge[] = [
  { from: 's_login', to: 'b_auth', phase: 'S1' },
  { from: 'b_auth', to: 'e_entra', phase: 'S1', live: 'entra' },
  { from: 's_servers', to: 'b_fleet', phase: 'S1' },
  { from: 'b_fleet', to: 'e_checkmk', phase: 'S1' },
  { from: 'b_fleet', to: 'b_catalog', phase: 'S1' },
  { from: 'b_catalog', to: 'e_ovh', phase: 'S1' },
  { from: 's_import', to: 'b_provisioning', phase: 'S1' },
  { from: 'b_provisioning', to: 'e_ansible', phase: 'S1' },
  { from: 'e_ansible', to: 'f_servers', phase: 'S1' },
  { from: 'b_provisioning', to: 'b_access', phase: 'S1' },
  { from: 'b_access', to: 'f_servers', phase: 'S1' },
  { from: 'e_checkmk', to: 'f_servers', phase: 'S1' },
  { from: 's_settings', to: 'b_access', phase: 'S1' },
  { from: 'e_checkmk', to: 'b_notif', phase: 'S1' },
  { from: 'b_notif', to: 'e_teams', phase: 'S1', live: 'teams' },
  { from: 'b_auth', to: 'b_audit', phase: 'S1' },
  { from: 'b_provisioning', to: 'b_audit', phase: 'S1' },
  { from: 'e_github', to: 'f_scaleway', phase: 'S1', live: 'github' },
  { from: 's_inventory', to: 'b_portal', phase: 'S2' },
  { from: 's_newproject', to: 'b_portal', phase: 'S2' },
  { from: 's_import', to: 'b_portal', phase: 'S2' },
  { from: 'b_portal', to: 'b_fleet', phase: 'S2' },
  { from: 'b_portal', to: 'b_scaffolder', phase: 'S2' },
  { from: 'b_scaffolder', to: 'e_github', phase: 'S2', live: 'github' },
  { from: 'e_github', to: 'f_catalog', phase: 'S2', live: 'github' },
  { from: 'e_github', to: 'f_repos', phase: 'S2', live: 'github' },
  { from: 'b_catalog', to: 'f_catalog', phase: 'S2' },
  { from: 's_newproject', to: 'b_github', phase: 'S2' },
  { from: 'b_github', to: 'e_github', phase: 'S2', live: 'github' },
  { from: 'b_portal', to: 'b_audit', phase: 'S2' },
  { from: 's_dashboard', to: 'b_decisions', phase: 'S3' },
  { from: 's_domains', to: 'b_decisions', phase: 'S3' },
  { from: 'b_decisions', to: 'e_kuma', phase: 'S3' },
  { from: 'b_decisions', to: 'e_rdap', phase: 'S3' },
  { from: 's_supervision', to: 'b_fleet', phase: 'S3' },
  { from: 's_routing', to: 'b_notif', phase: 'S3' },
  { from: 'b_notif', to: 'e_smtp', phase: 'S3' },
  { from: 'b_notif', to: 'e_sms', phase: 'S3' },
  { from: 'b_audit', to: 'e_siem', phase: 'S3' },
  { from: 's_search', to: 'b_portal', phase: 'S4' },
  { from: 's_audit', to: 'b_audit', phase: 'S4' },
  { from: 'b_portal', to: 'e_onepassword', phase: 'S4' },
  { from: 's_logs', to: 'b_logs', phase: 'L2' },
  { from: 'b_logs', to: 'e_loki', phase: 'L2' },
  { from: 'e_loki', to: 'f_servers', phase: 'L2' },
  { from: 'b_logs', to: 'e_github', phase: 'L2' },
  { from: 's_security', to: 'b_updates', phase: 'L3' },
  { from: 'b_updates', to: 'e_wazuh', phase: 'L3' },
  { from: 'b_updates', to: 'e_semaphore', phase: 'L3' },
  { from: 'e_semaphore', to: 'f_servers', phase: 'L3' },
  { from: 's_ssh', to: 'b_access', phase: 'L4' },
  { from: 'b_access', to: 'e_openbao', phase: 'L4' },
  { from: 'e_openbao', to: 'f_servers', phase: 'L4' },
  { from: 's_reports', to: 'b_order', phase: 'L5' },
  { from: 'b_order', to: 'e_semaphore', phase: 'L5' },
  { from: 'b_order', to: 'e_ovh', phase: 'L5' },
];

export const FEATURES: PlanFeature[] = [
  { id: 'f-login', phase: 'S1', live: 'entra', action: true, nodes: ['s_login', 'b_auth', 'e_entra'], edges: ['s_login__b_auth', 'b_auth__e_entra'] },
  { id: 'f-list', phase: 'S1', nodes: ['s_servers', 'b_fleet', 'e_checkmk', 'b_catalog', 'e_ovh'], edges: ['s_servers__b_fleet', 'b_fleet__e_checkmk', 'b_fleet__b_catalog', 'b_catalog__e_ovh'] },
  { id: 'f-page', phase: 'S1', nodes: ['s_servers', 'b_fleet', 'e_checkmk'], edges: ['s_servers__b_fleet', 'b_fleet__e_checkmk'] },
  { id: 'f-state', phase: 'S1', nodes: ['b_fleet', 'e_checkmk', 'f_servers'], edges: ['b_fleet__e_checkmk', 'e_checkmk__f_servers'] },
  { id: 'f-ovh', phase: 'S1', nodes: ['b_catalog', 'e_ovh'], edges: ['b_catalog__e_ovh'] },
  { id: 'f-enrol', phase: 'S1', live: 'enrolment', action: true, nodes: ['s_import', 'b_provisioning', 'e_ansible', 'b_access', 'f_servers', 'e_checkmk'], edges: ['s_import__b_provisioning', 'b_provisioning__e_ansible', 'e_ansible__f_servers', 'b_provisioning__b_access', 'b_access__f_servers', 'e_checkmk__f_servers'] },
  { id: 'f-ca', phase: 'S1', nodes: ['s_settings', 'b_access', 'f_servers'], edges: ['s_settings__b_access', 'b_access__f_servers'] },
  { id: 'f-teams', phase: 'S1', live: 'teams', action: true, nodes: ['e_checkmk', 'b_notif', 'e_teams'], edges: ['e_checkmk__b_notif', 'b_notif__e_teams'] },
  { id: 'f-audit', phase: 'S1', nodes: ['b_audit', 'b_auth', 'b_provisioning'], edges: ['b_auth__b_audit', 'b_provisioning__b_audit'] },
  { id: 'f-ci', phase: 'S1', nodes: ['e_github', 'f_scaleway'], edges: ['e_github__f_scaleway'] },
  { id: 'f-scaleway', phase: 'S1', live: 'scaleway', action: true, nodes: ['f_scaleway', 'e_github'], edges: ['e_github__f_scaleway'] },
  { id: 'f-lists', phase: 'S2', nodes: ['s_inventory', 'b_portal', 'b_fleet'], edges: ['s_inventory__b_portal', 'b_portal__b_fleet'] },
  { id: 'f-project', phase: 'S2', nodes: ['s_inventory', 'b_portal', 'b_fleet'], edges: ['s_inventory__b_portal', 'b_portal__b_fleet'] },
  { id: 'f-scope', phase: 'S2', nodes: ['s_inventory', 'b_portal', 'b_auth'], edges: ['s_inventory__b_portal'] },
  { id: 'f-catalog', phase: 'S2', live: 'github', action: true, nodes: ['b_portal', 'b_scaffolder', 'e_github', 'f_catalog', 'b_catalog', 'b_audit'], edges: ['b_portal__b_scaffolder', 'b_scaffolder__e_github', 'e_github__f_catalog', 'b_catalog__f_catalog', 'b_portal__b_audit'] },
  { id: 'f-qualif', phase: 'S2', nodes: ['s_inventory', 'b_portal', 'b_scaffolder', 'e_github'], edges: ['s_inventory__b_portal', 'b_portal__b_scaffolder', 'b_scaffolder__e_github'] },
  { id: 'f-newproject', phase: 'S2', nodes: ['s_newproject', 'b_portal', 'b_github', 'e_github', 'b_scaffolder', 'f_catalog', 'f_repos'], edges: ['s_newproject__b_portal', 's_newproject__b_github', 'b_github__e_github', 'b_portal__b_scaffolder', 'b_scaffolder__e_github', 'e_github__f_catalog', 'e_github__f_repos'] },
  { id: 'f-links', phase: 'S2', nodes: ['s_newproject', 'b_portal', 'b_fleet', 'b_scaffolder', 'e_github', 'f_catalog'], edges: ['s_newproject__b_portal', 'b_portal__b_fleet', 'b_portal__b_scaffolder', 'b_scaffolder__e_github', 'e_github__f_catalog'] },
  { id: 'f-attach', phase: 'S2', nodes: ['s_import', 'b_portal', 'b_scaffolder', 'e_github', 'f_catalog', 'b_catalog'], edges: ['s_import__b_portal', 'b_portal__b_scaffolder', 'b_scaffolder__e_github', 'e_github__f_catalog', 'b_catalog__f_catalog'] },
  { id: 'f-demo', phase: 'S2', nodes: ['e_checkmk', 'e_ovh', 'e_teams', 'e_github', 'e_sms'], edges: [] },
  { id: 'f-dashboard', phase: 'S3', nodes: ['s_dashboard', 'b_decisions'], edges: ['s_dashboard__b_decisions'] },
  { id: 'f-maintenance', phase: 'S3', nodes: ['s_supervision', 'b_fleet', 'e_checkmk'], edges: ['s_supervision__b_fleet', 'b_fleet__e_checkmk'] },
  { id: 'f-escalation', phase: 'S3', nodes: ['b_notif', 'e_smtp', 'e_sms', 'e_checkmk'], edges: ['b_notif__e_smtp', 'b_notif__e_sms', 'e_checkmk__b_notif'] },
  { id: 'f-routing', phase: 'S3', nodes: ['s_routing', 'b_notif'], edges: ['s_routing__b_notif'] },
  { id: 'f-probes', phase: 'S3', nodes: ['b_decisions', 'e_kuma'], edges: ['b_decisions__e_kuma'] },
  { id: 'f-domains', phase: 'S3', nodes: ['s_domains', 'b_decisions', 'e_rdap'], edges: ['s_domains__b_decisions', 'b_decisions__e_rdap'] },
  { id: 'f-siem', phase: 'S3', nodes: ['b_audit', 'e_siem'], edges: ['b_audit__e_siem'] },
  { id: 'f-cmdk', phase: 'S4', nodes: ['s_search', 'b_portal'], edges: ['s_search__b_portal'] },
  { id: 'f-auditscreen', phase: 'S4', nodes: ['s_audit', 'b_audit'], edges: ['s_audit__b_audit'] },
  { id: 'f-entra', phase: 'S4', nodes: ['b_auth', 'e_entra'], edges: ['b_auth__e_entra'] },
  { id: 'f-vaults', phase: 'S4', nodes: ['b_portal', 'e_onepassword'], edges: ['b_portal__e_onepassword'] },
  { id: 'f-acceptance', phase: 'S4', nodes: ['f_scaleway', 'f_servers'], edges: [] },
  { id: 'f-logs', phase: 'L2', nodes: ['s_logs', 'b_logs', 'e_loki', 'f_servers'], edges: ['s_logs__b_logs', 'b_logs__e_loki', 'e_loki__f_servers'] },
  { id: 'f-incidents', phase: 'L2', nodes: ['s_logs', 'b_logs'], edges: ['s_logs__b_logs'] },
  { id: 'f-deploys', phase: 'L2', nodes: ['b_logs', 'e_github', 'f_repos'], edges: ['b_logs__e_github', 'e_github__f_repos'] },
  { id: 'f-running', phase: 'S4', nodes: ['s_servers', 'b_fleet', 'e_checkmk', 'f_servers', 'b_portal', 'b_scaffolder', 'e_github', 'f_catalog'], edges: ['s_servers__b_fleet', 'b_fleet__e_checkmk', 'e_checkmk__f_servers', 'b_portal__b_scaffolder', 'b_scaffolder__e_github', 'e_github__f_catalog'] },
  { id: 'f-updates', phase: 'L3', nodes: ['s_security', 'b_updates', 'e_semaphore', 'f_servers'], edges: ['s_security__b_updates', 'b_updates__e_semaphore', 'e_semaphore__f_servers'] },
  { id: 'f-vulns', phase: 'L3', nodes: ['s_security', 'b_updates', 'e_wazuh'], edges: ['s_security__b_updates', 'b_updates__e_wazuh'] },
  { id: 'f-backups', phase: 'L3', nodes: ['s_security', 'b_updates', 'f_servers'], edges: ['s_security__b_updates'] },
  { id: 'f-ssh', phase: 'L4', nodes: ['s_ssh', 'b_access', 'e_openbao', 'f_servers'], edges: ['s_ssh__b_access', 'b_access__e_openbao', 'e_openbao__f_servers'] },
  { id: 'f-secrets', phase: 'L4', nodes: ['s_ssh', 'b_access', 'e_openbao'], edges: ['s_ssh__b_access', 'b_access__e_openbao'] },
  { id: 'f-order', phase: 'L5', nodes: ['s_reports', 'b_order', 'e_semaphore', 'e_ovh'], edges: ['s_reports__b_order', 'b_order__e_semaphore', 'b_order__e_ovh'] },
  { id: 'f-reports', phase: 'L5', nodes: ['s_reports', 'b_order'], edges: ['s_reports__b_order'] },
  { id: 'f-contracts', phase: 'L5', nodes: ['s_reports', 'b_order'], edges: [] },
];
